import { fetchContent } from "../../api/content";
import { fetchPathway } from "../../api/pathway";
import { ScreenState } from "../../components/ScreenState";
import { useSession } from "../../lib/session";
import { useAsync } from "../../lib/useAsync";
import { HubScreen } from "../../screens/hub/HubScreen";

export function HubRoute() {
  const { user } = useSession();
  const { data, loading, error, reload } = useAsync(
    () => Promise.all([fetchPathway(), fetchContent()]),
    [],
  );

  return (
    <ScreenState loading={loading} error={error} onRetry={reload}>
      {data && user?.track ? (
        <HubScreen
          {...data[0]}
          trackLabel={data[1].tracks[user.track].label}
          firstName={user.firstName}
        />
      ) : null}
    </ScreenState>
  );
}
